import React from 'react'
import dynamic from 'next/dynamic'

export const SelectionButtonItem = dynamic(
	async () => await import('./SelectionButtonItemComponent'),
	{
		ssr: false,
		loading: () => <></>,
	}
)